import s from "./ComponentTest.module.scss";
import type { RichTextContent } from "../../lib/storyblok/types/fieldtypes/richText";
import BlockIntro from "../Common/BlockIntro";

type Props = {
  content: RichTextContent;
  title: string;
};

const ComponentTest = ({ content, title }: Props) => (
  <section className={s.contact}>
    <BlockIntro title={title} description={content} alignment={"alignLeft"} />
  </section>
);

export default ComponentTest;
